import {Route, Routes, Outlet} from 'react-router-dom'
import {PageTitle} from '../../../../_metronic/layout/core'
import {PaymentSettingsListWrapper} from './payment-settings-list/PaymentSettingsList'

const PaymentSettingsPage = () => {
  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route
          path='/*'
          element={
            <>
              <PageTitle>Payment Settings</PageTitle>
              <PaymentSettingsListWrapper />
            </>
          }
        />
      </Route>
    </Routes>
  )
}

export default PaymentSettingsPage
